import { Component, ElementRef } from '@angular/core';
import { AppMenu } from './app.menu';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [AppMenu],
    template: `
        <div class="layout-sidebar">
            <!-- <div class="layout-sidebar-logo">
                <div class="logo-mark">
                    <svg viewBox="250 270 730 730" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="siom marble &amp; stones">
                        <rect x="250" y="270" width="730" height="730" rx="120" ry="120" fill="#ffffff" />
                        <path
                            d="M396 322 C472 399 493 538 456 641 C421 739 350 777 295 766"
                            fill="none"
                            stroke="#005b8f"
                            stroke-width="21"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <circle cx="410" cy="450" r="31" fill="#8b0048" />
                        <circle cx="600" cy="622" r="10" fill="#676767" />
                        <path d="M493 640 C399 674 340 762 366 889" fill="none" stroke="#666666" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                        <circle cx="406" cy="805" r="22" fill="#ffffff" stroke="#777777" stroke-width="1.5" />
                        <text x="716" y="818" text-anchor="middle" font-family="Helvetica Neue, Arial, Helvetica, sans-serif" font-size="208" font-weight="300" letter-spacing="-8" fill="#666666">siom</text>
                        <text x="716" y="891" text-anchor="middle" font-family="Helvetica Neue, Arial, Helvetica, sans-serif" font-size="54" font-weight="300" letter-spacing="-1" fill="#6f6f6f">marble &amp; stones</text>
                    </svg>
                </div>
                <div class="logo-text">
                    Siom Marble KPI
                    <span>Management System</span>
                </div>
            </div> -->
            <app-menu></app-menu>
        </div>
    `,
    styles: ``
})
export class AppSidebar {
    constructor(public el: ElementRef) {}
}
